import Image from 'next/image';

import watch from '@/components/Pages/EventDetail/assets/watch.svg';

export type EventItineraryBoxProps = {
  itinerary: string;
};

const EventItineraryBox = (props: EventItineraryBoxProps) => {
  const { itinerary } = props;

  return (
    <div
      className={`mt-[24px] flex w-full justify-center gap-[6.5px] rounded-[44px] border-[0.5px] border-green-300 py-[16px] font-roboto text-h4 font-bold`}
      style={{
        boxShadow: `0px 0px 24px rgba(26, 193, 181, 0.08)`,
      }}
    >
      <Image width={16} height={16} src={watch} alt="watch" />
      <span className={`text-b2 font-normal text-green-100`}>{itinerary}</span>
    </div>
  );
};

export default EventItineraryBox;
